/**
 * ANIMATION - INPUT RANGE - LISTENERS
 */

setupEventListenersForInputRange();

// Creates the event listeners
function setupEventListenersForInputRange() {  
  // On changing the value of the dual 'from' input of type range
  document.querySelectorAll('.dual-range-wrapper .from').forEach((element) => {
    element.addEventListener('input', changeDualFromRangeHandler);
  });
  
  // On changing the value of the dual 'to' input of type range
  document.querySelectorAll('.dual-range-wrapper .to').forEach((element) => {
    element.addEventListener('input', changeDualToRangeHandler);
  });
  
  // On changing the value of the dual 'from' input of type number
  document.querySelectorAll('.dual-range-linked .from').forEach((element) => {
    element.addEventListener('input', changeDualFromNumberHandler);
  });
  
  // On changing the value of the dual 'to' input of type number
  document.querySelectorAll('.dual-range-linked .to').forEach((element) => {
    element.addEventListener('input', changeDualToNumberHandler);
  });

  // On changing the value an input of type range
  document.querySelectorAll('.range-wrapper input[type="range"]').forEach((element) => {
    element.addEventListener('change', changeInputRangeHandler);
  });
}

// On page load
window.addEventListener('DOMContentLoaded', domContentloadedHandler);

/**
 * ANIMATION - INPUT RANGE - GENERAL
 */

// On page load
function domContentloadedHandler() {
  initRangeInputs();
}

// On changing the value of the dual 'from' input of type range
function changeDualFromRangeHandler() {
  changeDualRangeInput('from-range');
}

// On changing the value of the dual 'to' input of type range
function changeDualToRangeHandler() {
  changeDualRangeInput('to-range');
}

// On changing the value of the dual 'from' input of type number
function changeDualFromNumberHandler() {
  changeDualRangeInput('from-number');
}

// On changing the value of the dual 'to' input of type number
function changeDualToNumberHandler() {
  changeDualRangeInput('to-number');
}

// Initializes range inputs
function initRangeInputs() {
  initNormalRangeInputs();
  changeDualRangeInput('from-range');
}

/**
 * ANIMATION - INPUT RANGE - NORMAL
 */

// On changing the value an input of type range
function changeInputRangeHandler() {
  changeSelectedNormalRangeBackground(event.currentTarget);
}

// Initializes normal range inputs
function initNormalRangeInputs() {
  document.querySelectorAll('.range-wrapper input[type="range"]').forEach((element) => {
    changeSelectedNormalRangeBackground(element);
  });
}

// Changes the background color of the normal selected range
function changeSelectedNormalRangeBackground(input) {
  var rangeDistance = input.getAttribute('max') - input.getAttribute('min'),
      currentPosition = input.value - input.getAttribute('min'),        
      rangeColor = input.closest('.range-wrapper').dataset.bgColor,
      rangeSelectedColor = input.closest('.range-wrapper').dataset.selectedColor;

  var percentValue1 = (currentPosition) / (rangeDistance) * 100,
      percentValue2 = (currentPosition) / (rangeDistance) * 100,
      colorValueStart = rangeSelectedColor + ' 0%, ',
      colorValue1 = rangeSelectedColor + ' ' + percentValue1 + '%, ',
      colorValue2 = rangeColor + ' ' + percentValue2 + '%, ',      
      colorValueEnd = rangeColor + ' 100%)',
      backgroundValue = 'linear-gradient(to right, ' + colorValueStart + colorValue1 + colorValue2 + colorValueEnd;

  input.style.background = backgroundValue;
}

/**
 * ANIMATION - INPUT RANGE - DUAL
 */

// Changes the selected dual values of each concerned container
function changeDualRangeInput(trigger) {
  document.querySelectorAll('.dual-range-container').forEach((element) => {
    var rangeFrom = element.querySelector('input[type="range"].from'),
        rangeTo = element.querySelector('input[type="range"].to'),
        labelFrom = element.querySelector('label.from'),
        labelTo = element.querySelector('label.to'),
        numberFrom = element.querySelector('input[type="number"].from'),
        numberTo = element.querySelector('input[type="number"].to');

    switch(trigger) {
      case 'from-range':
        changeDualFromRange(rangeFrom, rangeTo, labelFrom, labelTo, numberFrom, numberTo);
        break;
      case 'to-range':
        changeDualToRange(rangeFrom, rangeTo, labelFrom, labelTo, numberFrom, numberTo);
        break;
      case 'from-number':
        changeDualFromNumber(rangeFrom, rangeTo, labelFrom, labelTo, numberFrom, numberTo);
        break;
      case 'to-number':
        changeDualToNumber(rangeFrom, rangeTo, labelFrom, labelTo, numberFrom, numberTo);
        break;
      default:          
    }
  });
}

// Changes the selected dual values (range and from)
function changeDualFromRange(rangeFrom, rangeTo, labelFrom, labelTo, numberFrom, numberTo) {
  const [from, to] = getParsed(rangeFrom, rangeTo);

  changeSelectedDualRangeBackground(rangeFrom, rangeTo, rangeTo);

  if (from > to) {
    rangeFrom.value = to;
    numberFrom.value = to;
    if (labelFrom !== null) labelFrom.textContent = Shopify.formatMoney(to * 100, window.theme.moneyFormat);
  } else {
    rangeFrom.value = from;
    numberFrom.value = from;
    if (labelFrom !== null) labelFrom.textContent = Shopify.formatMoney(from * 100, window.theme.moneyFormat);
  }
}

// Changes the selected dual values (range and to)
function changeDualToRange(rangeFrom, rangeTo, labelFrom, labelTo, numberFrom, numberTo) {
  const [from, to] = getParsed(rangeFrom, rangeTo);

  changeSelectedDualRangeBackground(rangeFrom, rangeTo, rangeTo);

  if (from <= to) {
    rangeTo.value = to;
    numberTo.value = to;
    if (labelTo !== null) labelTo.textContent = Shopify.formatMoney(to * 100, window.theme.moneyFormat);
  } else {
    rangeTo.value = from;
    numberTo.value = from;
    if (labelTo !== null) labelTo.textContent = Shopify.formatMoney(from * 100, window.theme.moneyFormat);
  }
}

// Changes the selected dual values (number and from)
function changeDualFromNumber(rangeFrom, rangeTo, labelFrom, labelTo, numberFrom, numberTo) {
  const [from, to] = getParsed(numberFrom, numberTo);

  changeSelectedDualRangeBackground(numberFrom, numberTo, rangeTo);

  if (from > to) {
    rangeFrom.value = to;
    numberFrom.value = to;
    if (labelFrom !== null) labelFrom.textContent = Shopify.formatMoney(to * 100, window.theme.moneyFormat);
  } else {
    rangeFrom.value = from;
    numberFrom.value = from;
    if (labelFrom !== null) labelFrom.textContent = Shopify.formatMoney(from * 100, window.theme.moneyFormat);
  }
}

// Changes the selected dual values (number and to)
function changeDualToNumber(rangeFrom, rangeTo, labelFrom, labelTo, numberFrom, numberTo) {
  const [from, to] = getParsed(numberFrom, numberTo);

  changeSelectedDualRangeBackground(numberFrom, numberTo, rangeTo);

  if (from <= to) {
    rangeTo.value = to;
    numberTo.value = to;
    if (labelTo !== null) labelTo.textContent = Shopify.formatMoney(to * 100, window.theme.moneyFormat);
  } else {
    rangeTo.value = from;
    numberTo.value = from;
    if (labelTo !== null) labelTo.textContent = Shopify.formatMoney(from * 100, window.theme.moneyFormat);
  }
}

// Gets the parsed value of 'from' and 'to' inputs
function getParsed(inputFrom, inputTo) {
  const from = parseInt(inputFrom.value, 10);
  const to = parseInt(inputTo.value, 10);
  
  return [from, to];
}

// Changes the background color of the dual selected range
function changeSelectedDualRangeBackground(inputFrom, inputTo, input) {
  var rangeDistance = inputTo.getAttribute('max') - inputTo.getAttribute('min'),
      fromPosition = inputFrom.value - inputTo.getAttribute('min'),
      toPosition = inputTo.value - inputTo.getAttribute('min'),        
      rangeColor = input.closest('.dual-range-wrapper').dataset.bgColor,
      rangeSelectedColor = input.closest('.dual-range-wrapper').dataset.selectedColor;

  var percentValue1 = (fromPosition) / (rangeDistance) * 100,
      percentValue2 = (fromPosition) / (rangeDistance) * 100,
      percentValue3 = (toPosition) / (rangeDistance) * 100,
      percentValue4 = (toPosition) / (rangeDistance) * 100,
      colorValueStart = rangeColor + ' 0%, ',
      colorValue1 = rangeColor + ' ' + percentValue1 + '%, ',
      colorValue2 = rangeSelectedColor + ' ' + percentValue2 + '%, ',
      colorValue3 = rangeSelectedColor + ' ' + percentValue3 + '%, ',
      colorValue4 = rangeColor + ' ' + percentValue4 + '%, ',        
      colorValueEnd = rangeColor + ' 100%)',
      backgroundValue = 'linear-gradient(to right, ' + colorValueStart + colorValue1 + colorValue2 + colorValue3 + colorValue4 + colorValueEnd;

  input.style.background = backgroundValue;
}